import React from 'react'

import SelectField from '~/components/Fields/SelectField'
import { LOCATION_STATUS } from '~/components/Statuses/LocationStatus'

export const OPTIONS = [
  { value: LOCATION_STATUS.ACTIVE, name: 'Active' },
  { value: LOCATION_STATUS.INACTIVE, name: 'Inactive' }
]

function LocationStatusField (props) {
  return (
    <SelectField
      name="status"
      label="Status"
      options={OPTIONS}
      {...props}
    />
  )
}

export default LocationStatusField
